<script lang="ts" module>
  import AddTab from '@/ui/elements/text-tab/AddTab.svelte';
  import TextTab from '@/ui/elements/text-tab/TextTab.svelte';

  import { useActiveTabId, useTabs } from './use-tabs.svelte';
</script>

<script lang="ts">
  let [tabs, { activateTab, closeTab, duplicateTab, updateTabTitle, createNewTab }] = useTabs();
  let activeTabId = useActiveTabId();
</script>

<div
  class="fr flex-1 items-stretch justify-start gap-2 overflow-x-scroll"
  style="scrollbar-width: none"
>
  {#each tabs.current as tab (tab.id)}
    <TextTab
      onclick={() => activateTab(tab.id)}
      selected={tab.id === activeTabId.current}
      title={tab.title}
      onClose={() => closeTab(tab.id)}
      onDuplicate={() => duplicateTab(tab.id)}
      onChangeTitle={(title) => updateTabTitle(tab.id, title)}
    />
  {/each}
  <AddTab onclick={createNewTab} />
</div>
